import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { Dialog, DialogTitle, DialogContent, Typography, IconButton } from '@material-ui/core';
import SimpleReactValidator from 'simple-react-validator';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';
import { StripeProvider, Elements, injectStripe, CardNumberElement, CardExpiryElement, CardCVCElement } from 'react-stripe-elements';
import { itemService, globalService as gs, defaultService } from '../../../../common/services';
import moment from 'moment-timezone';
import { confirmAlert } from 'react-confirm-alert';
import { alertSelectors } from '../../../../common/redux/selectors';
import { userActions } from '../../../../common/redux/actions';


const createOptions = (fontSize, padding) => {
    return {
      style: {
        base: {
          fontSize,
          color: '#495057',
          fontWeight: '100',
          letterSpacing: '0.025em',
          '::placeholder': {
            color: '#000',
          },
          padding,
        },
        invalid: {
          color: '#9e2146',
        },
      },
    };
};

class _CardForm extends React.Component {

    constructor(props) {

        super(props);
        this.state = {
            formField: {
                token: { id: '', email: '', coupon: '' },
                plan_id: '',
            },
            totalAmount: '',
            discount_price: '',
            error: '',
            couponCode: '',
            loading: false,
            loadingCouponCode: false,
        };
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            className: 'valid-feedback d-block text-danger',
        });
    }

    componentDidMount() {
        const { item, dispatch } = this.props;
        let formField = {...this.state.formField};
        formField['plan_id'] = item.id;
        let totalAmount = item.amount;
        this.setState({ formField, totalAmount });
    }

    handleChange = (e) => {
        const { name, value, checked, type } = e.target;
        let formField = {...this.state.formField};
        formField[name] = (type === 'checkbox') ? (checked === true) ? 1 : '' : value;
        this.setState({formField});
    };

    handleError = (change) => {
        if(change.complete) this.setState({error: ''});
    };

    handleSubmit = (e) => {
        e.preventDefault();
        console.log(this.state.formField);
        //return false;
        if( this.validator.allValid() ) {
            this.setState({loading: true});
            const { stripe, authentication, item, dispatch } = this.props;
            const { user } = authentication && authentication.authentication && authentication.authentication;
            let formField = {...this.state.formField};
            // console.log('subject[0].title', formField);
            if (Number(this.state.totalAmount) > 0) {
                if(stripe) {
                    stripe.createToken({price: this.state.totalAmount, name: user.name, email: user.email}).then((payload) => {
                        console.log('payload', payload)
                        if(payload && payload.token) {
                            formField['token'].id = payload.token.id;
                            formField['token'].email = payload.token.email;
                            //this.bookTutor(formField);
                            this.props.dispatch(userActions.membership("POST", formField, { plan_id: item.id }));
                            this.handleClose('done');
                            gs.messageAlert('Check your email to complete the sign up process.');
                        } else {
                            console.log("Stripe.js hasn't loaded yet.");
                            this.setState({loading: false, error: payload.error.message});
                            dispatch(alertSelectors.error(payload.error.message));
                        }
                    }, (error) => {
                        this.setState({loading: false, error: error.error.message});
                    });
                }
            } else {
                //delete formField.token;
                this.props.dispatch(userActions.membership("POST", formField, { plan_id: item.id }));
                this.handleClose('done');
                //this.bookTutor(formField);
            }
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    applyCouponCode = () => {
        const { dispatch, item } = this.props;
        if(this.state.couponCode.length < 1) return true;
        this.setState({loadingCouponCode: true});
        defaultService.coupons("GET", null, {code: this.state.couponCode}).then(data => {
            this.setState({loadingCouponCode: false});
            if(data.model !== null) {
                let formField = {...this.state.formField};
                let code = data.model;
                let old_price = (parseFloat(item.amount)).toFixed(2);
                let discount = code.discount;
                let discount_price = '';
                formField['token'].coupon = code.code;
                if(code.type === 'fixed') {
                    discount_price = parseFloat(discount).toFixed(2);
                } else {
                    const percentage = (old_price * discount / 100);
                    discount_price = parseFloat(percentage).toFixed(2);
                }
                let totalAmount = (parseFloat(old_price) - parseFloat(discount_price)).toFixed(2);
                this.setState({formField, discount_price, totalAmount});
                dispatch(alertSelectors.success('Coupon code apply'));
            }
            else {
                confirmAlert({
                    message: 'Coupon code not valid.',
                    buttons: [
                        {
                            label: 'Ok',
                            onClick: () => console.log('No')
                        }
                    ]
                });
            }
        })
        .catch(exception => {
            gs.showErrors(dispatch, exception, alertSelectors);
            this.setState({loadingCouponCode: false});
        });
    }

    handleClose = (e = null) => this.props.handleClose(e);

    render() {
        this.validator.purgeFields();
        const { loading, loadingCouponCode, discount_price, totalAmount } = this.state;
        const { item } = this.props;
        //const transaction_fee = config.config;
        //console.log('config', childsList);

        return (<form name="form" onSubmit={this.handleSubmit} noValidate>
            <div className="subject form-group">
                <label>Apply Coupon</label>
                <div className="input-group">
                    <input type="text" name="couponCode" className="form-control" value={this.state.couponCode} onChange={(e) => this.setState({couponCode: e.target.value})} />
                    <div className="input-group-append">
                        <button className="btn btn-secondary" type="button" onClick={this.applyCouponCode}>Apply {loadingCouponCode && <span className="spinner-border spinner-border-sm"></span>}</button>
                    </div>
                </div>
            </div>
            {(Number(totalAmount) > 0) &&
            <div className="card-details">
                <h3 className="font-weight-bold">Payment Detail</h3>
                <div className="row">
                    <div className="col-md-6 col-12">
                        <div className="form-group">
                            <label>Card number</label>
                            <CardNumberElement
                                onChange={this.handleError}
                                {...createOptions(this.props.fontSize)}
                            />
                        </div>
                    </div>
                    <div className="col-md-6 col-12">
                        <div className="form-group">
                            <label>Name of card holder</label>
                            <input type="text" className="form-control" />
                        </div>
                    </div>
                    <div className="col-md-6 col-12">
                        <div className="form-group">
                            <label>Expiration date</label>
                            <CardExpiryElement
                                onChange={this.handleError}
                                {...createOptions(this.props.fontSize)}
                            />
                        </div>
                    </div>
                    <div className="col-md-6 col-12">
                        <div className="form-group">
                            <label>CVC</label>
                            <CardCVCElement
                                onChange={this.handleError}
                                placeholder={''}
                                {...createOptions(this.props.fontSize)}
                            />
                        </div>
                    </div>
                </div>
                {(this.state.error) && <div className="valid-feedback d-block text-danger form-group">{this.state.error}</div>}
            </div>}

            <div className="subject form-group">
                <p><b>Discount:</b> {discount_price ? discount_price : '00.00'}</p>
                <b>Total Amount:</b> <big>{(parseFloat((item && item) ? item.amount : 0) - parseFloat(discount_price ? discount_price : 0)).toFixed(2)}</big>
            </div>

            <div className="form-group">
                {/* <button onClick={this.handleClose} type="button" className="btn btn-info">Cancel </button> */}
                <LaddaButton type="submit" className="btn btn-secondary text-white text-uppercase" loading={loading} data-style={EXPAND_RIGHT}>Pay Now</LaddaButton>
            </div>
        </form>)
    }
}

const CardForm = injectStripe(_CardForm);

class MemberShipDialog extends Component {

    handleClose = (e = null) => this.props.handleClose(e);

    componentDidMount() {
        
    }

    render() {
        const { open, item, dispatch, authentication } = this.props;
        return (<Dialog onClose={this.handleClose} open={open} className="booking-dialog" scroll={"body"}>
            <DialogTitle id="simple-dialog-title" disableTypography className="bg-info text-white text-center">
                <Typography variant="h6">Membership </Typography>
                <IconButton aria-label="close" className="closeButton" onClick={this.handleClose}>
                <i className="fas fa-times"></i>
                </IconButton>
            </DialogTitle>
            <DialogContent >
                <StripeProvider apiKey={process.env.REACT_APP_STRIPE_TEST_PUBLIC_KEY}>
                    <Elements>
                        <CardForm fontSize="16px" item={item && item} dispatch={dispatch} authentication={authentication && authentication} handleClose={(e) => this.handleClose(e)} />
                    </Elements>
                </StripeProvider>
            </DialogContent>
        </Dialog>);
    }
}


const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const processSelector = createSelector(
    state => state.process,
    process => process
);

const mapStateToProps = createSelector(
    processSelector,
    authenticationSelector,
    (process, authentication) => ({
        process, authentication
    })
);

export default connect(mapStateToProps)(MemberShipDialog);
